<template>
  <div ref="container">
    <a-modal :title="title" :width="800" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :pagination="pagination" :columns="columns" :loading="loading">
        <!-- <template slot="customRenderFlag" slot-scope="status">
          <a-tag v-if="status===0" color="green">启用</a-tag>
          <a-tag v-if="status===2" color="orange">禁用</a-tag>
        </template> -->
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { getSerNumbers } from '@/api/api'
export default {
  name: 'VendorModal',
  data() {
    return {
      title: '序列号',
      visible: false,
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      loading: false,
      columns: [
        {
          title: '序列号',
          dataIndex: 'code',
          width: 200,
        },
      ],
    }
  },
  created() {},
  methods: {
    async add(e) {
      console.log(e, 'e122')
      this.visible = true
      this.pagination.current = 1
      this.loading = true

      const res = await getSerNumbers({ id: e.id })
      console.log(res, 'res')
      if (res.code == 200) {
        this.loading = false
        this.dataSource = res.data.map((it) => {
          return { code: it }
        })
      } else {
        this.$message.error(res.data || res.msg)
        this.loading = false
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
    handlePageChange(page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>
<style scoped>
</style>